import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=c9634526"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports